import { render } from "./Page-Footer.vue?vue&type=template&id=49ac40b5&scoped=true"
import script from "./Page-Footer.vue?vue&type=script&lang=js"
export * from "./Page-Footer.vue?vue&type=script&lang=js"

import "./Page-Footer.vue?vue&type=style&index=0&id=49ac40b5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49ac40b5"

export default script